import { Routes, CanActivate } from '@angular/router';
import { searchFilterIndex } from '../search/search-filter-index/search-filter-index.routes';
import { dashboardPages } from '../dashboard/dashboard.routes';
import { AuthGuard } from 'src/app/guard/auth-guard';

export const mainMenuRoutes: Routes = [
  { path: '', redirectTo: 'home', pathMatch: 'full' },
  {
    path: 'home',
    loadComponent: () =>
      import('../home/home.page').then((m) => m.HomePage),
  },
  {
    path: 'our_story',
    loadComponent: () => import('../informations/story/story.page').then( m => m.StoryPage)
  },
  {
    path: 'contact-us',
    loadComponent: () => import('../informations/contact/contact.page').then( m => m.ContactComponent)
  },
  {
    path: 'join-us',
    loadComponent: () => import('../informations/join-us/join-us.page').then( m => m.JoinUsComponent)
  },
  {
    path: 'warranty',
    loadComponent: () => import('../informations/warranty/warranty.page').then( m => m.WarrantyPage)
  },
  {
    path: 'delivery',
    loadComponent: () => import('../informations/delivery/delivery.page').then( m => m.DeliveryPage)
  },
  {
    path: 'terms-conditions',
    loadComponent: () => import('../informations/terms-conditions/terms-conditions.page').then( m => m.TermsConditionsPage)
  },
  {
    path: 'refund',
    loadComponent: () => import('../informations/refund-policy/refund-policy.page').then( m => m.RefundPolicyPage)
  },
  {
    path: 'product-verification',
    loadComponent: () => import('../informations/product-verification/product-verification.page').then( m => m.ProductVerificationPage)
  },
  {
    path: 'guide',
    loadComponent: () => import('../informations/online-shopping-guide/online-shopping-guide.page').then( m => m.OnlineShoppingGuidePage)
  },
  {
    path: 'privacy-policy',
    loadComponent: () =>
      import('../informations/privacy-policy/privacy-policy.page').then((m) => m.PrivacyPolicyPage),
  },
  {
    path: 'faqs',
    loadComponent: () =>
      import('../informations/faqs/faqs.page').then((m) => m.FaqsComponent),
  },
  {
    path: 'cart',
    loadComponent: () =>
      import('../cart/cart.page').then((m) => m.CartPage),
  },
  {
    path: 'checkout',
    loadComponent: () => import('../checkout/checkout.page').then(m => m.CheckoutPage)
  },
  {
    path: 'view/:slug',
    loadComponent: () => import('../view-product/view-product.page').then(m => m.ViewProductPage)
  },
  {
    path: 'order/:id',
    loadComponent: () => import('../order/order.page').then(m => m.OrderPage)
  },
  {
    path: 'signup',
    loadComponent: () => import('../auth/signup/signup.page').then(m => m.SignupPage)
  },
  {
    path: 'signin',
    canActivate: [AuthGuard],
    data: { requireAuth: false },
    loadComponent: () => import('../auth/signin/signin.page').then(m => m.SigninPage)
  },
  {
    path: 'forgot-password',
    loadComponent: () => import('../auth/forgot-password/forgot-password.page').then(m => m.ForgotPasswordPage)
  },
  {
    path: 'verification',
    loadComponent: () => import('../auth/verification/verification.page').then(m => m.VerificationPage)
  },
  {
    path: 'reset-password',
    loadComponent: () => import('../auth/reset-password/reset-password.page').then(m => m.ResetPasswordPage)
  },
  {
    path: 'personal-info',
    loadComponent: () => import('../settings/personal-info/personal-info.page').then( m => m.PersonalInfoPage)
  },
  {
    path: 'wallet',
    loadComponent: () => import('../settings/wallet/wallet.page').then( m => m.WalletPage)
  },
  {
    path: 'search',
    children: searchFilterIndex,
    loadComponent: () => import('../search/search-filter-index/search-filter-index.page').then(m => m.SearchFilterIndexPage)
  },
  {
    path: 'orders',
    loadComponent: () => import('../my-orders/index/index.page').then(m => m.IndexPage)
  },
  {
    path: 'orders/view-order/:id',
    loadComponent: () => import('../my-orders/view-order/view-order.page').then(m => m.ViewOrderPage)
  },
  {
    path: 'shipping-address',
    loadComponent: () => import('../settings/shipping-address/shipping-address.page').then( m => m.ShippingAddressPage)
  },
  {
    path: 'validation',
    loadComponent: () => import('../validation/validation.page').then( m => m.ValidationPage)
  },
  {
    path: 'report-fake',
    loadComponent: () => import('../report/report.page').then(m => m.ReportPage)
  },
  {
    path: 'distributor',
    loadComponent: () => import('../informations/distributors/distributors.page').then( m => m.DistributorsPage)
  },
  {
    path: 'status',
    loadComponent: () => import('../informations/status/status.page').then(m => m.StatusPage)
  },
  {
    path: 'native',
    children: dashboardPages,
    loadComponent: () => import('../dashboard/dashboard.page').then(m => m.DashboardPage)
  },
  {
    path: 'anticipate',
    loadComponent: () => import('../anticipate/anticipate.page').then( m => m.AnticipatePage)
  },
  {
    path: 'info/:page',
    loadComponent: () => import('../informations/info/info.page').then(m => m.InfoPage)
  },
  {
    path: '**',
    loadComponent: () =>
      import('../page-not-found/page-not-found.page').then(
        (m) => m.PageNotFoundPage
      ),
  },
];
